import { CONSTANTS } from 'enum';
import { rest as API } from './rest';

export const oAuthCallback = ({ provider, query }) =>
  API.get(`/v2/auth/${provider}/callback${query}`).then((response) => response.data);

export const login = (credentials) => API.post(`v2/auth/login`, credentials).then((response) => response.data);

export const loginMFA = (credentials, code) =>
  API.post(`v2/auth/login`, credentials, { headers: { 'X-OTP': code } }).then((response) => response.data);

export async function logout() {
  const response = await API.post('/v2/auth/logout', {});
  return response.data;
}

export const resetPasswordEmail = ({ username }) => API.post('/v2/auth/resetpassword', { username });

export const updatePassword = (payload) => {
  const token = localStorage.getItem(CONSTANTS.LOCAL_ACCESS_TOKEN_KEY);
  return API.post(`/v2/auth/updatepassword?_token=${token}`, payload);
};
